import { selectDocumentTotal } from 'components/editor/grid/reduxStore/editorSlice';
import type { RootState } from 'components/editor/grid/reduxStore/Store';
import { useAppSelector } from 'components/editor/grid/reduxStore/Store';
import { PricingTotalType } from 'services/documents/entities';

export function usePricingTotals(totalType: PricingTotalType = PricingTotalType.CALCULATED, price = 0) {
  const rawTotal = useAppSelector((state: RootState) => selectDocumentTotal(state));
  const documentTotal = rawTotal ?? 0;

  const getCalculatedTotal = () => {
    return rawTotal;
  };

  if (totalType === PricingTotalType.MANUAL) {
    return { documentTotal: price, getCalculatedTotal: () => price };
  }

  return { documentTotal, getCalculatedTotal };
}
